<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  @if (this.vehicleId !== -1) {
    <div class="p-3">
      <div class="row mt-0 content-block-head mb-3">
        <div class="col p-3">
          <h4>Historic Inspections for {{this.vehicle.registration}}</h4>
        </div>
      </div>
      <div class="col mr-3 pt-3">
        <table class='table table-bordered'>
          <thead class='thead-dark'>
            <tr>
              <th>Inspection</th>
              <th>Date</th>
              <th>Next Date</th>
              <th>Defect</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (row of this.inspections; track row) {
              <tr>
                <td>{{row.inspectionInterval.name}}</td>
                <td>{{showDate(row.date)}}</td>
                <td>{{nextDate(row.date,row.inspectionInterval.number,row.inspectionInterval.unitAbbrev)}}</td>
                @if (row.defect !== null) {
                  <td>{{row.defect.description}}</td>
                  <td>
                    <button class='btn btn-info' routerLink='/4workshop/defect/{{row.defectId}}'><i class="fas fa-eye"></i></button>
                  </td>
                }
                @if (row.defect === null) {
                  <td>n/a</td>
                  <td></td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
